var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyChallengesFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.5C5.17157 19.5 4.5 20.1716 4.5 21C4.5 21.8284 5.17157 22.5 6 22.5V19.5ZM36.0607 22.0607C36.6464 21.4749 36.6464 20.5251 36.0607 19.9393L26.5147 10.3934C25.9289 9.80761 24.9792 9.80761 24.3934 10.3934C23.8076 10.9792 23.8076 11.9289 24.3934 12.5147L32.8787 21L24.3934 29.4853C23.8076 30.0711 23.8076 31.0208 24.3934 31.6066C24.9792 32.1924 25.9289 32.1924 26.5147 31.6066L36.0607 22.0607ZM6 22.5H35V19.5H6V22.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyChallengesFilled);
export default __webpack_public_path__ + "static/media/icon-myChallenges-filled.132135733a65f9e8a07c579efb4a340b.svg";
export { ForwardRef as ReactComponent };